/**
 * 功能: 报告中插入专家说附件的列表
 */

<template lang="pug">
  el-table(
    ref="quoteRef"
    :data="quoteData"
    style="width: 100%")
    el-table-column(
      type="index"
      label="编号"
      width="50")
    el-table-column(
      prop="subject"
      label="主题"
      width="120"
      show-overflow-tooltip)
    el-table-column(
      prop="expertName"
      label="专家名"
      width="80"
      align="center")
    //- el-table-column(
    //-   prop="industry"
    //-   label="行业"
    //-   width="120"
    //-   show-overflow-tooltip)
    //-   template(slot-scope="scope")
    //-     span(v-if="scope.row.industry" v-html="scope.row.industry.join('<br />')")
    el-table-column(
      prop="status"
      label="状态"
      width="90"
      align="center")
      template(slot-scope="scope")
        span {{ scope.row.status | status }}
    el-table-column(
      prop="content"
      label="内容"
      show-overflow-tooltip)
    el-table-column(
      label="操作"
      width="80"
      align="center")
      template(slot-scope="scope")
        el-button(:size="GLOBAL.SIZE_OF_INPUTBOX" @click="handleInsert(scope.row)") 插入
</template>

<script>
export default {
  props: {
    quoteData: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    // 专家说
    handleInsert (quoteInfo) {
      quoteInfo._class = 3
      this.$emit('getInsertData', quoteInfo, () => {
        this.$message({
          type: 'success',
          message: '临时插入附件成功！'
        })
      })
    }
  }
}
</script>

<style>

</style>
